import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enCommon from './locales/en/common.json';
import svCommon from './locales/sv/common.json';

const supportedLngs = ['en', 'sv'] as const;

void i18n
  .use(LanguageDetector) // detect from localStorage, navigator, etc.
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      sv: { common: svCommon }
    },

    // Key settings
    fallbackLng: 'en',
    supportedLngs,
    defaultNS: 'common',

    // Make 'sv-SE' → 'sv', 'en-GB' → 'en'
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    // Persist + detect order
    detection: {
      // 1) If user picked a language before, use it (persisted)
      // 2) Otherwise use browser/system (navigator)
      // 3) As a last resort, fallbackLng ('en')
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'preferred-language' // reuse your key
      // optional cookie name if you want cookie fallback:
      // lookupCookie: 'preferred-language'
    },

    interpolation: { escapeValue: false },
    returnNull: false,
    debug: process.env.NODE_ENV === 'development'
  });

// Keep <html lang="..."> in sync
i18n.on('languageChanged', (lng) => {
  document?.documentElement?.setAttribute('lang', lng);
});

export default i18n;
